import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraftState } from '../../services/agent-builder.interface';
import { PillKind, pillKind, pillLabel, stateDetail } from './status-pill.labels';

@Component({
  selector: 'app-status-pill',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="pill pill-{{ kind }}" [class.pill-lg]="large" [attr.title]="isAdmin ? technicalDetail : null"><span class="dot"></span>{{ label }}</span>`,
})
export class StatusPillComponent {
  @Input({ required: true }) state!: DraftState;
  @Input() large = false;
  /** Admins get the precise technical state as a hover tooltip; the visible
   *  label stays creator-friendly for everyone. */
  @Input() isAdmin = false;

  get kind(): PillKind { return pillKind(this.state); }
  get label(): string { return pillLabel(this.state); }
  get technicalDetail(): string { return stateDetail(this.state); }
}
